import baseApi from "./base"
import { ApplyRequest, ApplyResponse, ResendOtpRequest, ResendOtpResponse } from "./types/apply"
import { Apply2Request, Apply2Response } from "./types/apply2"
import { Apply3Request } from "./types/apply3"
import { BaseResponse } from "./types/common"
import { GetCaptcha1Response, GetCaptcha1Request } from "./types/captcha"
import { Apply4Request, Apply4Response } from "./types/apply4"
import { SubmitRequest } from "./types/submit"
import { AddMemberRequest, MemberResponse, RemoveMemberRequest } from "./types/member"

const api = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getTokenByTckn1: builder.mutation<BaseResponse, string>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body: {
          tckn: body,
          functionCode: "CUS0006",
          NextTransactionUrl: "Facebook/SocialMediaPortalCreateSession/GetTokenByTckn1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF",
        },
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getCaptcha: builder.mutation<GetCaptcha1Response, GetCaptcha1Request>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body: {
          tckn: body.tckn,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/AileBankaciligi/GetCaptcha1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    refreshCaptcha: builder.mutation<GetCaptcha1Response, GetCaptcha1Request>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body: {
          tckn: body.tckn,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/AileBankaciligi/RefreshCaptcha1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply: builder.mutation<ApplyResponse, ApplyRequest>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body: {
          tckn: body.tckn,
          cepTel: body.cepTel,
          dogumYil: body.dogumYil,
          dogumAy: body.dogumAy,
          dogumGun: body.dogumGun,
          captcha: body.captcha,
          kvkk: body.kvkk,
          cid: body.cid,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/AileBankaciligi/Apply1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    resendOtp: builder.mutation<ResendOtpResponse, ResendOtpRequest>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body: {
          tckn: body.tckn,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/AileBankaciligi/ResendOtp1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply2: builder.mutation<Apply2Response, Apply2Request>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body: {
          tckn: body.tckn,
          otp: body.otp,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/AileBankaciligi/Apply2",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply3: builder.mutation<BaseResponse, Apply3Request>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body: {
          tckn: body.tckn,
          kimlikSeriSiraNo: body.kimlikSeriSiraNo,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/AileBankaciligi/Apply3",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply4: builder.mutation<Apply4Response, Apply4Request>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body: {
          tckn: body.tckn,
          aileNo: body.aileNo,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/AileBankaciligi/Apply4",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    addMember: builder.mutation<MemberResponse, AddMemberRequest>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body: {
          tckn: body.tckn,
          memberTckn: body.memberTckn,
          memberRelationship: body.memberRelationship,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/AileBankaciligi/AddMember1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    removeMember: builder.mutation<MemberResponse, RemoveMemberRequest>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body: {
          tckn: body.tckn,
          memberId: body.memberId,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/AileBankaciligi/RemoveMember1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    submit: builder.mutation<BaseResponse, SubmitRequest>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body: {
          tckn: body.tckn,
          applicationDeclaration: body.applicationDeclaration,
          undividedAccountChoice: body.undividedAccountChoice,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/AileBankaciligi/Submit1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    })
  })
})

export const { useGetTokenByTckn1Mutation, useGetCaptchaMutation, useRefreshCaptchaMutation, useApplyMutation, useResendOtpMutation, useApply2Mutation, useApply3Mutation, useApply4Mutation, useAddMemberMutation, useRemoveMemberMutation, useSubmitMutation } = api

export default api
